<template>
  <div id="part2" class="bg-white">
    <b-row no-gutters>
      <b-col cols="12" sm="3">
        <div
          class="bg-hs-green text-white py-3 px-4 mb-4"
          style="border-bottom-right-radius: 28px"
        >
          <em>Donation Form <br />{{ checkout.Donor_Type }}</em>
        </div>
      </b-col>
      <b-col cols="12" sm="6" offset-sm="3" class="mb-3 mb-sm-0">
        <div class="px-5">
          <div>
            <div
              style="position: relative; height: 50px; width: 90%; margin: auto"
            >
              <span
                style="
                  width: 100%;
                  height: 3px;
                  display: block;
                  position: absolute;
                  top: calc(50% - 1.5px);
                "
                class="bg-hs-gray"
              ></span>
              <span
                style="
                  height: 3px;
                  display: block;
                  position: absolute;
                  top: calc(50% - 1.5px);
                  transition: all 0.5s ease-in;
                "
                class="bg-hs-light-green"
                :style="{ width: progressCss.percent }"
              ></span>
              <a
                href="#"
                @click.prevent="$emit(`back`)"
                style="
                  transition: all 0.5s ease-in;
                  width: 21px;
                  height: 21px;
                  border-radius: 50%;
                  display: block;
                  position: absolute;
                  top: calc(50% - 10.5px);
                  left: 0;
                "
                :class="progressCss.step0"
              ></a>
              <a
                href="#"
                v-if="!anon"
                @click.prevent="next_step(0)"
                style="
                  transition: all 0.5s ease-in;
                  width: 21px;
                  height: 21px;
                  border-radius: 50%;
                  display: block;
                  position: absolute;
                  top: calc(50% - 10.5px);
                  left: calc(33% - 7px);
                "
                :class="progressCss.step1"
              ></a>
              <a
                href="#"
                v-if="!anon"
                @click.prevent="next_step(1)"
                style="
                  transition: all 0.5s ease-in;
                  width: 21px;
                  height: 21px;
                  border-radius: 50%;
                  display: block;
                  position: absolute;
                  top: calc(50% - 10.5px);
                  left: calc(66% - 14px);
                "
                :class="progressCss.step2"
              ></a>
              <a
                href="#"
                @click.prevent="next_step(2)"
                style="
                  transition: all 0.5s ease-in;
                  width: 21px;
                  height: 21px;
                  border-radius: 50%;
                  display: block;
                  position: absolute;
                  top: calc(50% - 10.5px);
                  left: calc(100% - 21px);
                "
                :class="progressCss.step3"
              ></a>
            </div>
            <div style="position: relative; height: 30px">
              <div
                style="
                  font-size: 10px;
                  width: 15%;
                  text-align: center;
                  position: absolute;
                  top: 0;
                  left: 0;
                "
              >
                <a href="#" @click.prevent="$emit(`back`)" class="text-hs-black"
                  >Amount, Type, Frequency</a
                >
              </div>
              <div
                style="
                  font-size: 10px;
                  width: 15%;
                  text-align: center;
                  position: absolute;
                  top: 0;
                  left: 29%;
                "
              >
                <a
                  href="#"
                  v-if="!anon"
                  @click.prevent="next_step(0)"
                  class="text-hs-black"
                  >Personal Particulars</a
                >
              </div>
              <div
                style="
                  font-size: 10px;
                  width: 15%;
                  text-align: center;
                  position: absolute;
                  top: 0;
                  left: 57%;
                "
              >
                <a
                  href="#"
                  v-if="!anon"
                  @click.prevent="next_step(1)"
                  class="text-hs-black"
                  >Tax Deduction</a
                >
              </div>
              <div
                style="
                  font-size: 10px;
                  width: 15%;
                  text-align: center;
                  position: absolute;
                  top: 0;
                  left: 85%;
                "
              >
                <a href="#" @click.prevent="next_step(2)" class="text-hs-black"
                  >Payment</a
                >
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <div class="bg-hs-crimson-6 py-3 px-5 mb-5" v-if="step < 2 && !anon">
      <b-row>
        <b-col style="padding-right: 0; max-width: 220px">
          <b-row no-gutters style="margin-bottom: 8px; display: flex">
            <div class="info-caption">Donate as:</div>
            <div class="info-bubble" style="font-size: 14px; line-height: 22px">
              {{ checkout.Donor_Type }}
            </div>
          </b-row>
          <b-row no-gutters style="margin-bottom: 8px">
            <div class="info-caption">Frequency:</div>
            <div class="info-bubble" style="font-size: 14px; line-height: 22px">
              {{ freq }}
            </div>
          </b-row>
        </b-col>
        <b-col style="padding-left: 0; flex: 1">
          <b-row no-gutters style="margin-bottom: 8px; display: flex">
            <div class="info-caption">Amount:</div>
            <div
              class="info-bubble"
              style="color: #8c0303; font-size: 14px; line-height: 22px"
            >
              SGD {{ checkout.Donation_Cash_Value }}
            </div>
          </b-row>
          <b-row no-gutters style="margin-bottom: 8px; display: flex">
            <div class="info-caption">Payment method:</div>
            <div class="info-bubble" style="font-size: 14px; line-height: 22px">
              {{ checkout.Donation_Mode }}
            </div>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div class="px-5 pb-5">
      <template v-if="checkout.Donor_Type != `Anonymous`">
        <b-form @submit.prevent="next_step(1, true)" v-if="step === 0">
          <individual
            :checkout="checkout"
            v-if="checkout.Donor_Type == 'Individual'"
          />
          <corporate
            :checkout="checkout"
            v-else-if="checkout.Donor_Type == 'Corporate'"
          />
          <inhonor
            :checkout="checkout"
            v-else-if="checkout.Donor_Type == 'On Behalf'"
          />
          <div
            class="text-right d-flex d-sm-block flex-column-reverse align-items-stretch"
          >
            <b-button
              class="mr-sm-1 mt-sm-0 mt-1"
              style="padding: 0.5rem 3rem"
              @click="$emit(`back`)"
              >Back</b-button
            >
            <b-button
              type="submit"
              style="padding: 0.5rem 3rem"
              variant="hs-green"
              class="text-white"
              >Next</b-button
            >
          </div>
        </b-form>
        <b-form @submit.prevent="next_step(2, true)" v-if="step === 1">
          <tax :checkout="checkout" />
          <div
            class="text-right d-flex d-sm-block flex-column-reverse align-items-stretch mt-3"
          >
            <b-button
              class="mr-sm-1 mt-sm-0 mt-1"
              style="padding: 0.5rem 3rem"
              @click="next_step(0)"
              >Back</b-button
            >
            <b-button
              type="submit"
              style="padding: 0.5rem 3rem"
              variant="hs-green"
              class="text-white"
              >Next</b-button
            >
          </div>
        </b-form>
        <div v-if="step === 2">
          <checkout ref="checkout" :checkout="checkout" :axios="axios" />
        </div>
      </template>
      <div v-else>
        <checkout ref="checkout" :checkout="checkout" :axios="axios" />
      </div>
    </div>
  </div>
</template>

<script>
import corporate from "./part2/corporate.vue";
import individual from "./part2/individual.vue";

import tax from "./part2/tax.vue";
import checkout from "./part2/checkout.vue";

import inhonor from "./part2/inhonor.vue";
import VueScrollTo from "vue-scrollto";

export default {
  name: "part2",
  components: {
    individual,
    corporate,
    inhonor,
    tax,
    checkout,
  },
  props: {
    checkout: Object,
    axios: Function,
  },
  data() {
    return {
      step: 0,
    };
  },
  methods: {
    async next_step(step, from_form) {
      if (this.checkout.Reference) {
        let r = confirm(
          "This will clear and cancel the current transaction. Are you sure?"
        );
        if (r) {
          if (this.$refs.checkout) {
            this.$refs.checkout.submitting = true;
          }
          try {
            await this.axios.delete("donations/" + this.checkout.Reference);
          } catch {
            //do nothing
            alert("CANNOT DELETE");
          }
          window.location.reload();
          return;
        }
        return;
      }
      if (from_form) {
        this.step = step;
      }
      if (this.step >= step) {
        this.step = step;
      } else {
        alert("You need to clear the previous step before proceeding");
      }
    },
  },
  watch: {
    step() {
      VueScrollTo.scrollTo(this.$parent.$refs.main, 400);
    },
  },
  computed: {
    anon() {
      return this.checkout.Donor_Type == "Anonymous";
    },
    freq() {
      switch (this.checkout.Donation_Frequency) {
        case -1:
          return "Once";
        case 1:
          return "Monthly";
        case 6:
          return "Half-Yearly";
        case 12:
          return "Annually";
      }
      return "";
    },
    progressCss() {
      let active = "bg-hs-dark-turquoise";
      let complete = "bg-hs-light-green";
      let inactive = "bg-hs-gray";
      let step = this.step;

      if (this.anon) {
        return {
          percent: "100%",
          step0: complete,
          step3: active,
        };
      }
      return {
        percent: (100 * (step + 1)) / 3 + "%",
        step0: complete,
        step1: step === 0 ? active : complete,
        step2: step === 1 ? active : step < 1 ? inactive : complete,
        step3: step === 2 ? active : inactive,
      };
    },
  },
};
</script>
